export const esimInfoData = {
  title: "es.esim_info.title",
  sections: [
    {
      heading: "es.esim_info.sections.0.heading",
      content: [
        {
          details: "es.esim_info.sections.0.content.0.details",
        },
        {
          subheading: "es.esim_info.sections.0.content.1.subheading",
          details: "es.esim_info.sections.0.content.1.details",
        },
      ],
    },
    {
      heading: "es.esim_info.sections.1.heading",
      content: [
        {
          details: "es.esim_info.sections.1.content.0.details",
        },
        {
          subheading: "es.esim_info.sections.1.content.1.subheading",
          details: "es.esim_info.sections.1.content.1.details",
        },
      ],
    },
    {
      heading: "es.esim_info.sections.2.heading",
      content: [
        {
          details: "es.esim_info.sections.2.content.0.details",
        },
        {
          subheading: "es.esim_info.sections.2.content.1.subheading",
          details: "es.esim_info.sections.2.content.1.details",
        },
        {
          subheading: "es.esim_info.sections.2.content.2.subheading",
          details: "es.esim_info.sections.2.content.2.details",
        },
        {
          subheading: "es.esim_info.sections.2.content.3.subheading",
          details: "es.esim_info.sections.2.content.3.details",
        },
        {
          subheading: "es.esim_info.sections.2.content.4.subheading",
          details: "es.esim_info.sections.2.content.4.details",
        },
      ],
    },
    {
      heading: "es.esim_info.sections.3.heading",
      table: {
        headers: ["es.esim_info.sections.3.table.headers.0", "es.esim_info.sections.3.table.headers.1", "es.esim_info.sections.3.table.headers.2"],
        rows: [
          ["es.esim_info.sections.3.table.rows.0.0", "es.esim_info.sections.3.table.rows.0.1", "es.esim_info.sections.3.table.rows.0.2"],
          ["es.esim_info.sections.3.table.rows.1.0", "es.esim_info.sections.3.table.rows.1.1", "es.esim_info.sections.3.table.rows.1.2"],
          ["es.esim_info.sections.3.table.rows.2.0", "es.esim_info.sections.3.table.rows.2.1", "es.esim_info.sections.3.table.rows.2.2"],
          ["es.esim_info.sections.3.table.rows.3.0", "es.esim_info.sections.3.table.rows.3.1", "es.esim_info.sections.3.table.rows.3.2"],
          ["es.esim_info.sections.3.table.rows.4.0", "es.esim_info.sections.3.table.rows.4.1", "es.esim_info.sections.3.table.rows.4.2"],
          ["es.esim_info.sections.3.table.rows.5.0", "es.esim_info.sections.3.table.rows.5.1", "es.esim_info.sections.3.table.rows.5.2"],
          ["es.esim_info.sections.3.table.rows.6.0", "es.esim_info.sections.3.table.rows.6.1", "es.esim_info.sections.3.table.rows.6.2"],
        ],
      },
    },
    {
      heading: "es.esim_info.sections.4.heading",
      content: [
        {
          details:
            "es.esim_info.sections.4.content.0.details",
        },
        {
          subheading: "es.esim_info.sections.4.content.1.subheading",
          details:
            "es.esim_info.sections.4.content.1.details",
        },
        {
          subheading: "es.esim_info.sections.4.content.2.subheading",
          details:
            "es.esim_info.sections.4.content.2.details",
        },
        {
          subheading: "es.esim_info.sections.4.content.3.subheading",
          details:
            "es.esim_info.sections.4.content.3.details",
        },
        {
          subheading: "es.esim_info.sections.4.content.4.subheading",
          details:
            "es.esim_info.sections.4.content.4.details",
        },
        {
          subheading: "es.esim_info.sections.4.content.5.subheading",
          details:
            "es.esim_info.sections.4.content.5.details",
        },
      ],
    },
  ],
}